/**
 * Homepage Logic Module
 *
 * Proxy exports for all homepage utilities
 */

// Static blocks (sezione sotto al booking-engine, differenziati per package_type)
export { STATIC_BLOCKS } from './static-blocks';